import UNISWAP_V2_FACTORY_ABI from './uniswap-v2-factory.json'

const UNISWAP_V2_FACTORY_ADDRESS = '0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f'

export { UNISWAP_V2_FACTORY_ADDRESS, UNISWAP_V2_FACTORY_ABI }
